import React from "react"
export function Amendment(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M14.665 11.036L17.79 14.1a.744.744 0 01.074.98l-.074.083-3.125 3.065-1.056-1.064 1.685-1.652-.38-.009-.163-.01-.3-.032c-1.377-.167-2.423-.58-3.121-1.268l-.144-.152 1.112-1.003.102.105c.471.446 1.294.742 2.488.853l.221.01.39.004.058-.001-1.948-1.91 1.056-1.063zm0-9.764l3.125 3.065a.744.744 0 01.074.979l-.074.084-3.125 3.064-1.056-1.063 1.752-1.719-1.058.004c-2.774-.005-4.079 1.222-4.15 3.915l-.004.242c0 3.65-2.301 5.59-6.579 5.697l-.295.005-1.272.003L2 14.045l1.27-.003c3.61-.02 5.295-1.306 5.382-3.98l.003-.219c0-3.609 1.88-5.574 5.393-5.657l.254-.003 1.187-.004-1.88-1.843 1.056-1.064zM3.287 4.42l.342.003c1.903.042 3.32.434 4.242 1.224l.167.153-1.04 1.079-.118-.106c-.619-.514-1.707-.812-3.273-.847l-.32-.003H2.002V4.419h1.285z"
        fill="currentColor"
      />
    </svg>
  )
}
